import { render } from "./RegisterCTA.vue?vue&type=template&id=b917d790"
const script = {}

import "./RegisterCTA.vue?vue&type=style&index=0&id=b917d790&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__